
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/decisions/[year]",
      function () {
        return require("private-next-pages/sitemap/decisions/[year].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap/decisions/[year]"])
      });
    }
  